import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "../components/ui/dropdown-menu";
import { Bug, User, LogOut, Settings, BookOpen } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();

  return (
    <header className="app-header h-14" data-testid="app-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between">
        {/* Logo */}
        <Link to="/dashboard" className="flex items-center gap-2" data-testid="header-logo">
          <div className="w-8 h-8 rounded-sm bg-foreground flex items-center justify-center">
            <Bug className="w-5 h-5 text-background" />
          </div>
          <span className="font-black text-lg tracking-tight font-heading hidden sm:inline">
            RAG Debugger
          </span>
        </Link>

        {/* Navigation */}
        <div className="flex items-center gap-2">
          <Link to="/docs">
            <Button variant="ghost" size="sm" className="flex items-center gap-2" data-testid="docs-link">
              <BookOpen className="w-4 h-4" />
              <span className="hidden sm:inline">Docs</span>
            </Button>
          </Link>

          {/* User Menu */}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="flex items-center gap-2" data-testid="user-menu-button">
                <div className="w-8 h-8 rounded-full bg-muted flex items-center justify-center">
                  <User className="w-4 h-4 text-muted-foreground" />
                </div>
                <span className="hidden sm:inline text-sm font-medium">{user?.name}</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
              <DropdownMenuItem disabled>
                <Settings className="w-4 h-4 mr-2" />
                Settings
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={logout} data-testid="logout-button">
                <LogOut className="w-4 h-4 mr-2" />
                Sign Out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
